import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { ModalLogoHeader } from '@evdy/web-core/dist/components/shared/Modal2020';
import { useHideIntercom } from '@evdy/web-core/dist/customHooks';

import { webCommunityOperations } from '@evdy/web-redux/dist/lib/webCommunity';
import { API_URL } from '@evdy/web-redux/dist/constants';

import GetAppInfoVideoPlayer from './GetAppInfoVideoPlayer';
import HelpSection from '../HelpSection';

import styles from './GetAppInfo.module.scss';

import videoPlayButton from '../../public/images/icons/landscape_play_btn.png';

const { trackAccessorGetApp } = webCommunityOperations;

const {
  'get-app-info-container': getAppInfoContainerClass,
  'logo-header': headerClass,
  'get-app-btn': getTheAppBtnClass,
  'content-footer-container': contentAndFooterContainer,
  'border-content-separator': contentSeparatorClass,
  'video-play-image': videoPlayImageClass,
  'how-it-works-btn': howItWorksBtnClass,
  'help-section': helpSectionClass,
  title: titleClass,
  subtitle: subTitleClass,
  footer: footerClass
} = styles;

const Footer = ({ memorialId, userId }) => (
  <div className={footerClass}>
    <a href={`${API_URL}/apps/${userId}/${memorialId}`} className={getTheAppBtnClass}>
      <p>Get the free app to start</p>
    </a>
  </div>
);

const GetAppInfo = ({ location, params }) => {
  const dispatch = useDispatch();
  const { memorialId, userId } = params || {};

  //for classes on video element - only show full screen when playing
  const [isPlaying, setIsPlaying] = useState(null);

  const videoPlayerRef = useRef(null);

  const pageTitle = 'Make sure everyone has the service details they need';
  const pageSubtitle =
    'Our app makes it easy to text out beautiful invitations to your phone contacts. Everyone gets their own personal invite in just one click.';

  //set video to full screen and play
  const handlePlayVideo = ref => {
    ref.current.toggleFullscreen();
    ref.current.play();
    setIsPlaying(true);
  };

  useHideIntercom('memorial', { showAfterClose: false });

  //POST tracking info to accessor/userId in query params on mount
  useEffect(() => {
    dispatch(trackAccessorGetApp({ memorialId, userId, pageName: 'landing' }));
  }, []);

  //detect if video is fullscreen and pause video when not
  useEffect(() => {
    const fullScreenChangeCb = () => {
      const isVideoFullscreen = videoPlayerRef.current?.getState().player.isFullscreen;
      !isVideoFullscreen && videoPlayerRef.current.pause();
      !isVideoFullscreen && setIsPlaying(false);
    };
    // iOS cb only fires on end of full screen && see note
    // note: iOS returns true for videoPlayerRef.current?.getState().player.isFullscreen;
    const fullScreenChangeiOSCb = () => {
      videoPlayerRef.current && videoPlayerRef.current.pause();
      setIsPlaying(false);
    };
    //add event listeners for chrome/iOS devices - iOS event is added to video
    const currentVideo = videoPlayerRef.current?.video.video;

    document.addEventListener('fullscreenchange', fullScreenChangeCb);
    currentVideo.addEventListener('webkitendfullscreen', fullScreenChangeiOSCb);

    return () => {
      document.removeEventListener('fullscreenchange', fullScreenChangeCb);
      currentVideo.removeEventListener('webkitendfullscreen', fullScreenChangeiOSCb);
    };
  }, []);

  return (
    <>
      <ModalLogoHeader customClass={headerClass} />
      <div className={contentAndFooterContainer}>
        <div className={getAppInfoContainerClass}>
          <div className={titleClass}>{pageTitle}</div>
          <div className={subTitleClass}>{pageSubtitle}</div>
          <GetAppInfoVideoPlayer {...{ isPlaying }} videoRef={videoPlayerRef} />
          <img
            className={videoPlayImageClass}
            onClick={() => handlePlayVideo(videoPlayerRef)}
            src={videoPlayButton}
            alt="custom-play-btn"
          />
          <button className={howItWorksBtnClass} onClick={() => handlePlayVideo(videoPlayerRef)}>
            Watch how it works
          </button>
          <div className={contentSeparatorClass} />
        </div>
        <HelpSection customClass={helpSectionClass} />
      </div>
      <Footer {...{ memorialId, userId }} />
    </>
  );
};

export default GetAppInfo;
